import React, { Component, Fragment } from "react";
import InferenceProvider, {
  InferenceContext,
} from "../Context/InferenceProvider";
import Debugger from "../Debugger.js";
import ShowInfoSandbox from "../Pages/Components/ShowInfoSandbox.js";
import ButtonRuleMaker from "./Deducer Tools/ButtonRuleMaker";
import InferenceButtonMaker from "./Deducer Tools/InferenceButtonMaker.js";
import ShowInformationsExercise from "./Deducer Tools/ShowInformationsExercise";
import ShowPossibleMeaning from "./Deducer Tools/ShowPossibleMeaning";
import ShowPossibleSolutions from "./Deducer Tools/ShowPossibleSolutions";
// import Debugger from "../Debugger";

// Cette classe est appelée dans Calcul des propositions. Elle affiche la totalité des composants nécessaires à une déduction.
// Elle réceptionne un exercice et son contenu, et le redistribue à différentes classes et fonctions.
// Elle réceptionne InferenceContext, qui va véhiculer les infos de chaque nouvelle inférence.
class Deducer extends Component {
  state = {
    currentExercise: {},
  };

  renderDebugger(value) {
    let result = "";
    if (value.booleansOptionsAboutInferences.boolDebugger) {
      result = <Debugger valueInference={value} />; /* on affiche le debugger */
    }
    return result;
  }

  render() {
    let exerciseSolutionData = "",
      optimalLineNumber = "",
      classNameDeducerSandbox = "",
      classNameDeducerContentPanelSandbox = "";
    if (this.props.exerciseSolutionData) {
      exerciseSolutionData = this.props.exerciseSolutionData;
      optimalLineNumber =
        exerciseSolutionData[this.props.exerciseNumber - 1].possibleSolution
          .length;
    }
    console.log("miaou", this.state.exerciseSandbox);
    if (this.props.exerciseSandbox !== undefined) {
      console.log("MIAOU");
      classNameDeducerSandbox = "deducer-workspace-sandbox";
      classNameDeducerContentPanelSandbox = "deducer-content-panel-sandbox";
    }

    if (Object.keys(this.state.currentExercise).length === 0) {
      // On regarde si l'objet contient des clés, grâce à Object.keys (qui renvoie les clés sous forme de tableau). C'est plus fiable de le faire comme ça que de vérifier si c'est un tableau vide. (Cette ligne est importante surtout pour l'instant de react où le state est vide, de ce que j'ai compris.)
      return "Cet exercice a mal été chargé.";
    } else {
      return (
        <InferenceProvider
          conclusionSent={this.state.currentExercise.conclusion} // on l'envoie à InferenceProvider, qui vérifiera si la conclusion a été atteinte
          meaningSent={this.state.currentExercise.meaning} // je crois que ça sert à rien
        >
          <InferenceContext.Consumer>
            {(value) => {
              // A) (méga important) on permet à tout ce qui est dans la balise InferenceContext.Consumer, d'avoir accès au state déclaré dans InferenceProvider (pour cela il faut employer la variable value)
              // B) Ajouté par IA : 0. Register a callback with the parent that will: 1. Reset the deduction state 2. Close any open rule modals. (This callback will be executed when navigating between exercises)
              this.props.setCallback &&
                this.props.setCallback(() => {
                  value.resetDeduction();
                  value.setRuleModal(false);
                });
              return (
                <Fragment>
                  <div
                    className={`deducer-workspace ${classNameDeducerSandbox} colorInterface${value.booleansOptionsAboutInferences.actualInterfaceColor}`}
                  >
                    {/* niveau de couleur d'interface 1 */}
                    <ShowInformationsExercise
                      valueInference={value} // on envoie le state déclaré dans InferenceProvider
                      exerciseSent={this.state.currentExercise} // on envoie les données de l'exercice actuel
                      optimalLineNumber={optimalLineNumber}
                    />
                    <ShowInfoSandbox
                      valueInference={value}
                      exerciseSent={this.state.currentExercise}
                      premissesSent={this.state.currentExercise.premisses}
                    />
                    <section
                      className={
                        "deducer-main colorInterface" +
                        value.booleansOptionsAboutInferences
                          .actualInterfaceColor
                      }
                    >
                      {/* seulement deux child : #rules-panel et #deduction-panel */}
                      <div
                        id="rules-panel"
                        className={`deducer-content-panel ${classNameDeducerContentPanelSandbox}`}
                      >
                        {/* niveau de couleur d'interface : 3 */}
                        <ul id="rules-wrapper">
                          <ButtonRuleMaker
                            rulesSent={this.state.currentExercise.rulesImplied}
                            valueInference={value}
                            colorInterface={
                              value.booleansOptionsAboutInferences
                                .actualInterfaceColor
                            }
                          />
                        </ul>
                      </div>
                      <div
                        id="deduction-panel"
                        className={`deducer-content-panel colorInterface
                          ${value.booleansOptionsAboutInferences.actualInterfaceColor} ${classNameDeducerContentPanelSandbox}`}
                      >
                        {/* niveau de couleur d'interface : 3 */}
                        <ul
                          className={
                            "options-panel colorInterface" +
                            value.booleansOptionsAboutInferences
                              .actualInterfaceColor
                          }
                          id="InferenceButtons"
                        >
                          {/* niveau de couleur d'interface : 5 */}
                          {<InferenceButtonMaker valueInference={value} />}
                        </ul>
                        {value.showAllInferences() /* on affiche le tableau */}
                      </div>
                    </section>
                    {/* (journal) niveau de couleur d'interface : 3 */}
                    {value.journal}
                    {this.renderDebugger(value)}
                    <ShowPossibleMeaning
                      exerciseSent={this.state.currentExercise}
                      valueInference={value}
                    />
                    <ShowPossibleSolutions
                      valueInference={value}
                      exerciseSolutionData={exerciseSolutionData}
                    />
                  </div>
                </Fragment>
              );
            }}
          </InferenceContext.Consumer>
        </InferenceProvider>
      );
    }
  }

  componentDidMount() {
    let exerciseToBeMount = "";
    if (this.props.exerciseData) {
      exerciseToBeMount =
        this.props.exerciseData[Number(this.props.exerciseNumber - 1)];
      // () => consolelog("currentExercice", this.state.currentExercise) // consolelog avec une fonction avec fat arrow, oui ça existe
    }
    if (this.props.exerciseSandbox) {
      exerciseToBeMount = this.props.exerciseSandbox;
    }
    this.setState({ currentExercise: exerciseToBeMount });
  }

  static getDerivedStateFromProps(props) {
    // Fonction qui se fait à chaque fois qu'on navigue vers la page actuelle
    // (on part de CalculDesProps pour arriver à CalculDesProps)
    // ici on change de numéro d'exercice (sans recharger la page)
    if (
      props.exerciseNumber >= 1 &&
      props.exerciseNumber <= props.exerciseData.length
    ) {
      return {
        currentExercise: props.exerciseData[Number(props.exerciseNumber - 1)],
        // nextProps contient les données du futur rechargement de la page, c'est hyper important
      };
    }
    return null;
  }
}

export default Deducer;



// WEBPACK FOOTER //
// ./src/components/Calcul Tools/Deducer.js